import { render, staticRenderFns } from "./SiteIntroduction.vue?vue&type=template&id=3e90c8f2&scoped=true&"
import script from "./SiteIntroduction.vue?vue&type=script&lang=js&"
export * from "./SiteIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90c8f2",
  null
  
)

export default component.exports